import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const apiClient = axios.create({
  baseURL: API_URL,
  withCredentials: true, // <-- Rất quan trọng! Cho phép axios gửi và nhận cookie.
});

// Interceptor xử lý Refresh Token tự động
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Bỏ qua lỗi 401 nếu API là đăng nhập hoặc đang gọi chính API refresh token hoặc được yêu cầu bỏ qua refresh
    if (
      originalRequest.url.includes('/auth/login') || 
      originalRequest.url.includes('/auth/refresh-token') ||
      originalRequest.skipRefresh // <-- Thêm điều kiện này
    ) {
      return Promise.reject(error);
    }

    // Nếu lỗi 401 (Unauthorized) và chưa từng thử retry request này
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true; // Đánh dấu đã thử refresh

      try {
        // Xin cấp lại token (Backend tự đọc Cookie và set lại Cookie mới)
        await apiClient.post('/auth/refresh-token');

        // Refresh thành công, tiến hành gọi lại Request gốc (đã thất bại lúc máy cạn AccessToken)
        return apiClient(originalRequest);
      } catch (refreshError) {
        // Refresh thất bại (hết hạn 30 ngày hoặc cookie bị can thiệp) -> Logout ép buộc
        console.error("Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.");

        // Phát dispatch hoặc gọi Event để Frontend đẩy user ra ngoài LoginPage
        // Dùng Event cho đơn giản vì file API không có hook Navigate
        window.dispatchEvent(new Event('auth:unauthorized'));

        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;